import { generateKeyBetween } from 'fractional-indexing';
import { svg2Node } from '../lib/svg';
import { updateChildrenRecursively } from '../lib/interactive';
import { TYPES } from '../render/constants';
import { Action } from './action';
import { pasteNodesSync } from './copy';

function condition() {
  return true;
}

export const splitSvgAction = new Action({
  name: 'Split SVG',
  handler: splitSvg,
  condition: condition,
});

async function getImageContent(stageContext, node) {
  const content = await stageContext.providers.asset.getAsset(node.src);
  return fetch(content).then((res) => res.text());
}

async function splitSvg(stageContext, node) {
  const nodes = stageContext.api.getSelectedNodes();
  node = node || nodes[0];
  if (!node) return;
  const content = await getImageContent(stageContext, node);
  const result = svg2Node(content, {
    w: node.w,
    h: node.h,
  });
  result.root.type = TYPES.group;
  result.root.w = node.w;
  result.root.h = node.h;
  const payload = {
    nodes: [result.root],
    shallowNodes: [...Object.values(result.nodes)],
    assets: [],
  };

  const newNodes = pasteNodesSync(stageContext, payload);
  const newNode = newNodes[0];

  const children = stageContext.api.getChildren(newNode.id);
  const childrenBox = stageContext.api.getNodesRegion(children);

  const { interactive } = stageContext.providers;
  const scaleX = node.w / childrenBox.w;
  const scaleY = node.h / childrenBox.h;
  updateChildrenRecursively(interactive, children, {
    scaleX,
    scaleY,
  });
  interactive.cacheMovingNode = {};

  const index = generateKeyBetween(node.index, null);
  stageContext.api.updateNode(newNode.id, {
    parentId: node.parentId,
    index: index,
    x: node.x,
    y: node.y,
  });
  stageContext.api.removeNode(node.id);
}
